import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import AdminDashboard from './AdminDashboard';
import CoachDashboard from './CoachDashboard';
import SwimmerDashboard from './SwimmerDashboard';
import ParentDashboard from './ParentDashboard';

const Dashboard = () => {
  const { getUserRole } = useAuth();
  const userRole = getUserRole();

  // Render appropriate dashboard based on user role
  switch (userRole) {
    case 'admin':
      return <AdminDashboard />;
    case 'coach':
      return <CoachDashboard />;
    case 'parent':
      return <ParentDashboard />;
    case 'swimmer':
    default:
      return <SwimmerDashboard />;
  }
};

export default Dashboard; 